import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CallToActionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"call_to_action"}/>
}
